const CHANNEL_CODE_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
const OPERATION_PATTERN = /^[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*$/;

function quotaApiPath(channelCode, operation) {
  if (!CHANNEL_CODE_PATTERN.test(channelCode || '')) {
    throw new Error('渠道编码格式错误');
  }
  if (!OPERATION_PATTERN.test(operation || '')) {
    throw new Error('接口路径格式错误');
  }
  return `/api/external/quota/${channelCode}/${operation}`;
}

function ensureOrderNo(orderNo) {
  if (!orderNo) throw new Error('订单号为空');
  return orderNo;
}

function buildQuotaGetOptions(channelCode, operation, orderNo, params) {
  return {
    url: quotaApiPath(channelCode, operation),
    method: 'get',
    params: {
      ...(params || {}),
      orderNo: ensureOrderNo(orderNo),
    },
  };
}

function buildQuotaPostOptions(channelCode, operation, orderNo, data) {
  return {
    url: quotaApiPath(channelCode, operation),
    method: 'post',
    data: {
      ...(data || {}),
      orderNo: ensureOrderNo(orderNo),
    },
  };
}

module.exports = {
  buildQuotaGetOptions,
  buildQuotaPostOptions,
  quotaApiPath,
};
